// extracted by mini-css-extract-plugin
export default {"honestSign":"src-components-HonestSign--honestSign","hint":"src-components-HonestSign--hint"};